var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpSymbolikuvitus128011(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 129 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1507_14644)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.5 0H0.5V128H128.5V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.97 89C59.3763 89.9945 60.0572 90.8528 60.9331 91.4747C61.8091 92.0966 62.844 92.4563 63.9168 92.5119C64.9896 92.5675 66.0561 92.3166 66.9916 91.7886C67.9272 91.2605 68.6931 90.4772 69.2 89.53C67.9425 89.725 66.6725 89.8286 65.4 89.84C63.2298 89.832 61.0694 89.5497 58.97 89Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.28 84.0596C61.2623 84.6736 63.3248 84.9904 65.4 84.9996C66.7432 84.9973 68.0829 84.8633 69.4 84.5996",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.99 75.4697C83.6212 74.5166 84.173 73.5132 84.64 72.4697",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.95 68.49C86.9863 63.8718 86.4322 59.039 84.3775 54.7752C82.3227 50.5115 78.8879 47.0669 74.63 45",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.11 80.6702C77.739 78.6148 77.9812 76.4957 78.8063 74.577C79.6314 72.6583 81.0029 71.0248 82.75 69.8802C83.7319 69.242 84.8134 68.7722 85.95 68.4902",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.32 82.39C56.192 80.6641 57.5479 79.2296 59.2221 78.262C60.8962 77.2945 62.8161 76.8357 64.7468 76.9417C66.6776 77.0478 68.5356 77.7142 70.0937 78.8594C71.6517 80.0046 72.8424 81.5789 73.52 83.39C75.1579 82.6999 76.7005 81.8026 78.11 80.72",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6 43.4899C68.9012 43.0538 67.1539 42.8354 65.4 42.8399C59.8152 42.8479 54.4617 45.0706 50.5136 49.0205C46.5655 52.9705 44.3453 58.3252 44.34 63.9099C44.34 64.3799 44.34 64.8499 44.41 65.3199L55.24 71.1499C56.91 72.0499 58.07 75.1499 54.34 77.4599C53.43 78.0199 52.28 78.6499 51.06 79.2899",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.56 73.5195C88.7621 75.4617 87.7348 77.3014 86.5 78.9995",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.33 74.6804C47.6099 73.9143 47.6043 73.0729 47.3141 72.3106C47.0239 71.5484 46.4686 70.9163 45.75 70.5303C45.6247 70.4636 45.4943 70.4067 45.36 70.3604",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.79 76.6397L42.5 76.5297C41.7976 76.1498 41.2513 75.5348 40.9569 74.7924C40.6625 74.0501 40.6388 73.2278 40.89 72.4697",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5 62.7198C36.88 61.7198 34.38 63.7198 35.08 67.1298C35.7992 70.8428 36.32 74.5914 36.64 78.3598C36.7044 78.8912 36.7978 79.4187 36.92 79.9398L21.12 109.28L26.74 112.28L28.97 113.48L30.89 109.92L28.66 108.72L30.05 106.14L32.28 107.34L34.2 103.78L31.97 102.58L42.23 83.5398C42.433 83.4682 42.6302 83.3813 42.82 83.2798C42.82 83.2798 44.38 82.5698 46.43 81.5898",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.25 100.39L104.25 95.1197L98.5 94.5097L100.37 89.3097L97.37 84.6797C96.5813 85.8708 95.5611 86.891 94.37 87.6797C92.9508 88.6075 91.3277 89.1771 89.64 89.3397L100.31 105.68C101.915 106.095 103.541 106.429 105.18 106.68C106.03 106.81 106.12 106.68 106.52 105.47C106.99 104.03 107.9 100.78 107.9 100.78L102.25 100.39Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.28 87.3398C54.2992 87.9188 54.3729 88.4947 54.5 89.0598C55.0105 91.2707 56.2577 93.2422 58.0368 94.6506C59.8159 96.0589 62.021 96.8204 64.29 96.8098L69.55 120L69.85 119.93L73.71 119.06L80.5 117.49L79.65 113.75L72.9 115.29L71.9 110.87L78.65 109.34L77.8 105.61L71.05 107.14L68.5 95.8699C69.9744 95.1714 71.2556 94.1228 72.2317 92.8155C73.2078 91.5082 73.8492 89.982 74.1 88.3699C72.5259 88.9255 70.9016 89.3273 69.25 89.5698C68.7452 90.53 67.975 91.3249 67.0313 91.8598C66.0876 92.3948 65.01 92.6472 63.9269 92.5872C62.8438 92.5271 61.8007 92.1571 60.9219 91.5211C60.0431 90.8851 59.3656 90.0099 58.97 88.9998",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.28 84.0596C59.6644 83.3682 60.1898 82.7653 60.822 82.2899C61.4542 81.8145 62.1791 81.4771 62.95 81.2996C64.2417 81.0088 65.5944 81.176 66.7764 81.7725C67.9585 82.369 68.8965 83.3577 69.43 84.5696C70.8263 84.3043 72.1905 83.892 73.5 83.3396",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.41 65.32L40.05 63C39.8691 62.9042 39.682 62.8207 39.49 62.75",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.91 72.47C40.9676 72.276 41.0446 72.0884 41.14 71.91C41.5326 71.1807 42.1786 70.6204 42.9561 70.3348C43.7336 70.0493 44.5887 70.0582 45.36 70.36",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.43 72.9999C95.937 70.7108 93.6139 69.0904 90.95 68.4799C90.6504 70.1911 90.1745 71.8667 89.53 73.4799C90.0482 74.2689 90.2339 75.2306 90.0466 76.1557C89.8594 77.0809 89.3143 77.8946 88.53 78.4199C88.136 78.676 87.6955 78.852 87.2335 78.9378C86.7715 79.0236 86.2972 79.0176 85.8375 78.9201C85.3779 78.8226 84.9419 78.6355 84.5546 78.3695C84.1672 78.1036 83.8361 77.7639 83.58 77.3699C83.3239 76.976 83.1479 76.5354 83.0621 76.0734C82.9763 75.6115 82.9823 75.1371 83.0798 74.6775C83.1773 74.2178 83.3644 73.7819 83.6304 73.3945C83.8964 73.0072 84.236 72.676 84.63 72.4199C85.1981 71.1333 85.6369 69.7934 85.94 68.4199C84.8034 68.7019 83.7219 69.1717 82.74 69.8099C81.5718 70.5711 80.5653 71.5552 79.7781 72.7059C78.9908 73.8566 78.4383 75.1513 78.1522 76.5159C77.8661 77.8805 77.852 79.2881 78.1107 80.6581C78.3695 82.0281 78.896 83.3337 79.66 84.4999C79.81 84.7399 79.99 84.9599 80.16 85.1799C81.8644 87.2293 84.2785 88.5614 86.921 88.9106C89.5636 89.2598 92.2408 88.6006 94.4191 87.0643C96.5974 85.528 98.117 83.2274 98.675 80.6209C99.233 78.0144 98.7884 75.2934 97.43 72.9999Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.05 88.37C76.2183 87.6036 78.2761 86.5546 80.17 85.25",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.28 84.0596C58.5732 85.2879 58.352 86.7363 58.66 88.1196C58.7422 88.433 58.8458 88.7403 58.97 89.0396",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.95 68.45C91.2301 66.9528 91.3741 65.4332 91.38 63.91C91.3672 58.7991 89.8484 53.8053 87.0134 49.5527C84.1784 45.3002 80.1529 41.9775 75.44 40",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.66 38.5097C68.9361 38.1075 67.1702 37.9127 65.4 37.9297C58.7263 37.9482 52.3152 40.5322 47.494 45.1468C42.6727 49.7614 39.8106 56.0532 39.5 62.7197",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.43 38.35C60.8888 37.3816 61.613 36.5634 62.5185 35.9904C63.4239 35.4175 64.4735 35.1133 65.545 35.1133C66.6165 35.1133 67.6661 35.4175 68.5715 35.9904C69.477 36.5634 70.2012 37.3816 70.66 38.35",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.43 39.87C75.3802 39.2916 75.2764 38.7191 75.12 38.16C74.5015 35.9766 73.1588 34.0686 71.3125 32.7492C69.4661 31.4299 67.226 30.7778 64.96 30.9L58.58 8L58.28 8.08L54.5 9.18L47.83 11.05L48.83 14.73L55.5 12.87L56.72 17.23L50.05 19.09L51.05 22.78L57.72 20.92L60.83 32.05C59.3902 32.8198 58.1607 33.9304 57.2491 35.2848C56.3374 36.6393 55.7712 38.1963 55.6 39.82",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6 43.5C70.1319 44.449 69.4075 45.2481 68.5089 45.8068C67.6102 46.3656 66.5732 46.6617 65.515 46.6617C64.4568 46.6617 63.4198 46.3656 62.5211 45.8068C61.6225 45.2481 60.8981 44.449 60.43 43.5C59.0516 43.8442 57.7115 44.3266 56.43 44.94C57.2037 46.7125 58.4777 48.2209 60.0958 49.2801C61.714 50.3394 63.606 50.9036 65.54 50.9036C67.474 50.9036 69.366 50.3394 70.9842 49.2801C72.6023 48.2209 73.8763 46.7125 74.65 44.94",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.63 45C75.3303 43.4322 75.6095 41.7088 75.44 40",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.67 38.5C70.8132 38.7924 70.9303 39.097 71.02 39.41C71.4 40.7743 71.25 42.2318 70.6 43.49",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.27 82.4903V82.3904C51.9733 80.5664 49.2143 77.9075 47.27 74.6804C46.4427 73.3203 45.7718 71.8711 45.27 70.3604",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.28 87.3402C54.2014 85.6653 54.5453 83.9975 55.28 82.4902",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.91 72.4697C41.4113 73.9129 42.0405 75.3084 42.79 76.6397C43.8043 78.4426 45.026 80.1206 46.43 81.6397C48.6639 84.0306 51.3266 85.9811 54.28 87.3897",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1507_14644"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpSymbolikuvitus128011);
export default __webpack_public_path__ + "static/media/OP_symbolikuvitus_128_011.f6bcfa35161cdef1b01b44e5a1f210ea.svg";
export { ForwardRef as ReactComponent };